import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';

import MobileNav from './MobileNav';

import { CursorContext } from '../context/CursorContext';

function Header() {
  const navigationMenu = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Projects', path: '/projects' },
    { name: 'Contact', path: '/contact' },
  ];

  const [menuLinks, setMenuLinks] = useState (navigationMenu.filter((menuLink) => 
  menuLink.path !== window.location.pathname));

  const deleteMenuLink = (e) => {
    setMenuLinks(navigationMenu.filter((menuLink) => 
    menuLink.path !== e.target.pathname));
  };

  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const [showHeader, setShowHeader] = useState(true);
  
  const handleScroll = () => {
    const currentScrollPos = window.scrollY;
    const scrollingUp = currentScrollPos < prevScrollPos;
  
    if (window.innerWidth < 1024) {
      setShowHeader(scrollingUp || currentScrollPos === 0);
    } else {
      setShowHeader(true);
    }
    setPrevScrollPos(currentScrollPos);
  };
  
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
  
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollPos]);

  const { mouseEnterHandler, mouseLeaverHandler} = useContext(CursorContext)
  
  return (
    <header className={`
      ${showHeader ? 'translate-y-0' : 'transform -translate-y-full'}
      fixed top-0
      flex
      justify-end
      w-full
      lg:p-8 p-4
      bg-primary
      text-secondary
      transition-transform 
    `}>
      <div className='hidden md:flex text-xl gap-6'  style={{ fontFamily: 'Ledger, serif' }}>
        {menuLinks && menuLinks.length
        ? menuLinks.map((menuLink, index) => (
          <Link
          to= {menuLink.path}
          key={index}
          onClick={deleteMenuLink}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaverHandler}
          className='hover:underline'
          >
            {menuLink.name}
          </Link>
        ))
        : null
        }
      </div>
      <MobileNav />
    </header>
  );
}

export default Header;
